import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCircle, faStamp, faRulerCombined, faBell, faHome, faBed, faMapPin, faBath, faCar, faRuler, faPhone, faShare, faXmarkCircle, faCamera, faComment, faQuestionCircle, faUserAlt,
    faEye, faDollarSign, faPen, faBan, faSearch, faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight, faLevelDownAlt, faAlignJustify, faRulerHorizontal, faCarAlt, faBookmark as faBookmarkSolid
} from '@fortawesome/free-solid-svg-icons';
import { faClock, faBookmark } from '@fortawesome/free-regular-svg-icons';

export const iconBed = <FontAwesomeIcon fixedWidth icon={faBed} />;
export const iconBath = <FontAwesomeIcon fixedWidth icon={faBath} />;
export const iconParking = <FontAwesomeIcon fixedWidth icon={faCar} />;
export const iconPropertySize = <FontAwesomeIcon fixedWidth icon={faRuler} />;
export const iconTimeOnMarket = <FontAwesomeIcon fixedWidth icon={faClock} />;
export const iconPhone = <FontAwesomeIcon fixedWidth icon={faPhone} />;
export const iconShare = <FontAwesomeIcon fixedWidth icon={faShare} />;
export const iconClose = <FontAwesomeIcon fixedWidth icon={faXmarkCircle} />;
export const iconCamera = <FontAwesomeIcon fixedWidth icon={faCamera} />;
export const iconSend = <FontAwesomeIcon fixedWidth icon={faComment} />;
export const iconQuestion = <FontAwesomeIcon fixedWidth icon={faQuestionCircle} />;
export const iconUser = <FontAwesomeIcon fixedWidth icon={faUserAlt} />;
export const iconEye = <FontAwesomeIcon fixedWidth icon={faEye} />;
export const iconDollar = <FontAwesomeIcon fixedWidth icon={faDollarSign} />;
export const iconPen = <FontAwesomeIcon fixedWidth icon={faPen} />;
export const iconCancel = <FontAwesomeIcon fixedWidth icon={faBan} />;
export const iconApply = <FontAwesomeIcon fixedWidth icon={faSearch} />;
export const doubleLeftIcon = <FontAwesomeIcon fixedWidth icon={faAngleDoubleLeft} />;
export const leftIcon = <FontAwesomeIcon fixedWidth icon={faAngleLeft} />;
export const doubleRightIcon = <FontAwesomeIcon fixedWidth icon={faAngleDoubleRight} />;
export const rightIcon = <FontAwesomeIcon fixedWidth icon={faAngleRight} />;
export const iconHome = <FontAwesomeIcon fixedWidth icon={faHome} />;
export const iconLocation = <FontAwesomeIcon fixedWidth icon={faMapPin} />;
export const iconSearch = <FontAwesomeIcon fixedWidth icon={faSearch} />;
export const iconBell = <FontAwesomeIcon fixedWidth icon={faBell} />;
export const iconSize = <FontAwesomeIcon fixedWidth icon={faRulerCombined} />;
export const iconStatus = <FontAwesomeIcon fixedWidth icon={faStamp} />;
export const iconMarker = <FontAwesomeIcon fixedWidth icon={faCircle} />;
export const iconBasement = <FontAwesomeIcon fixedWidth icon={faLevelDownAlt} />;
export const iconDescriptionContains = <FontAwesomeIcon fixedWidth icon={faAlignJustify} />;
export const iconFrontage = <FontAwesomeIcon fixedWidth icon={faRulerHorizontal} />;
export const iconCar = <FontAwesomeIcon fixedWidth icon={faCarAlt} />;
export const iconBookmark = <FontAwesomeIcon fixedWidth icon={faBookmark} />;
export const iconBookmarkSolid = <FontAwesomeIcon fixedWidth icon={faBookmarkSolid} />;